import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ShareWidget from './share';
import CommentsWidget from './comments';
import TranscriptsWidget from './transcripts';


class Widgets extends Component {
    constructor(props) {
        super(props);
        require('./widgets.scss')
    }

    render() {
        const { share, comments, transcripts } = this.props;
        return (
            <div className="mtv-widgets-container">
                { share ? <ShareWidget /> : null }
                { comments ? <CommentsWidget /> : null }
                { transcripts ? <TranscriptsWidget /> : null }
            </div>
        )
    }
    static get propTypes() {
        return {
            share: PropTypes.bool,
            comments: PropTypes.bool,
            transcripts: PropTypes.bool
        }
    }

    static get defaultProps() {
        return {
            share: false,
            comments: false,
            transcripts: false
        }
    }
}

export default Widgets;